<template>
    <div class="formula-department-container" v-loading="loading">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'部门选择'">
            <!-- <div class="leader_style_menu_tree" style="margin-left: 10px"> -->
            <div class="leader-title" style="margin-top: 17px;margin-bottom: 20px;">部门选择</div>
            <me-tree
                ref="myTree"
                :treeData="data"
                :treeLoading="treeLoading"
                :treeToolBar="treeToolBar"
                :defaultProps="defaultUnitProps"
                :nodeKey="'target_unit_id'"
                :showIconKey="'node_expression'"
                :defaultExpandedKeys="defaultCheckKeys"
                nodeKeyName="target_unit_name"
                @handleAddTreeNode="handleAddTreeNode"
                @handleEditTreeNode="handleEditTreeNode"
                @handleDelTreeNode="handleDelTreeNode"
                @handleTreeNodeClick="handleTreeNodeClick"
            ></me-tree>
            <!-- </div> -->
        </me-collapes>
        <div class="leader-tab power-tab right_container border-left" :style="{ width: width }">
            <div class="point-tree">
                <me-tree
                    ref="myPointTree"
                    :treeData="pointData"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :defaultExpandedKeys="defaultPointCheckKeys"
                    :nodeKey="'point_id'"
                    :defaultExpandAll="false"
                    @handleTreeNodeClick="handlePointNodeClick"
                ></me-tree>
            </div>
            <el-scrollbar style="width: calc(100% - 300px);  height: calc(100% - 60px)">
                <div class="caculate-wrap">
                    <div 
                        v-for="(item, index) in expressionList"
                        :key="index"
                        class="point_date"
                    >
                        <el-radio v-model="curUnitExpressionId" :label="item.unit_expression_id" @change="changeDateRadio()">{{""}}</el-radio>
                        <el-date-picker
                            v-model="item.start_time"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH"
                            placeholder="开始日期">
                        </el-date-picker>
                        <el-date-picker
                            v-model="item.end_time"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH"
                            style="margin-left: 10px;">
                        </el-date-picker>
                        <el-button
                            class="leader-common-button"
                            style="margin-left: 10px !important;background-color: #ff6637;border-color: #ff6637;color: #fff"
                            size="small"
                            @click="doAddDate()"
                            v-if="index == expressionList.length-1"
                            >+</el-button
                        >
                        <el-button
                            class="leader-common-button"
                            style="margin-left: 10px !important;background-color: #ff6637;border-color: #ff6637;color: #fff"
                            size="small"
                            @click="doMinusDate()"
                            v-if="index > 0 && index == expressionList.length-1"
                            >-</el-button
                        >
                    </div>
                    <div class="formulaWrapper">
                        <div class="text-wrap">
                            <div v-for="(item, index) in nodelist" :key="index" @mouseover="curHoverItem=item" @mouseout="curHoverItem=null" :class="[item.point_name ? (curPoint && curPoint.id == item.id?'text-div border-check':'text-div border-uncheck') : 'text-div border-unwrite']">
                                <div :class="[item.type=='a' ? 'text_single single_btn': 'text_single']" @click="curPoint = item">{{item.point_name}}</div>
                                    
                                <i :class="[curHoverItem==item || (curPoint && curPoint.id == item.id) ? 'el-icon-plus doicon doiconmargin' : 'el-icon-plus doicon doiconmargin icon_hidden']" @click="changelist(0, item, index)"></i>
                                <i :class="[curHoverItem==item || (curPoint && curPoint.id == item.id) ? 'el-icon-close doicon' : 'el-icon-plus doicon icon_hidden']" @click="changelist(1, item, index)"></i>
                            </div>
                            <div @click="changelist(2, item)" class="plus_btn">
                                <i class="el-icon-plus"></i>
                            </div>
                        </div>
                    </div>
                   
                    <div class="express-btn">
                        <div
                            class="express-item"
                            v-for="item in expreeBtns"
                            :key="item + 'i'"
                            @click="clickCaculateBtn(item)"
                        >
                            {{ item }}
                        </div>
                    </div>
                    <div class="btn-wrap">
                        <div class="btn-inner-wrap">
                            <div class="btn-save" @click="saveTargetExpression">保存</div>
                            <div class="btn-clear" @click="resetExpress">清除</div> 
                        </div>
                    </div>
                </div>
            </el-scrollbar>
        </div>
        <unit-dialog
            :dialogVisible.sync="unitVisible"
            :unitId="unitId"
            :pUnitId="pUnitId"
            :treeUnitId="treeUnitId"
            :title="title"
            :target_unit_type="target_unit_type"
            :unitName="unitName"
            :sharp_price="sharp_price"
            :peak_price="peak_price"
            :off_price="off_price"
            :shoulder_price="shoulder_price"
            @closeCb="closeUnitTree"
            @appendTreeNode="appendTreeNode"
        ></unit-dialog>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import UnitDialog from "./components/unit-dialog.vue";
import {
    getTargetUnitTreeList,
    delTargetUnitTree,
    getTargetExpressionById,
    saveTargetExpression,
    getPointTree,
    getTargetMainList,
} from "@/http/target-config.js";
import { getPointList } from "@/http/api.js"
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes,
        "unit-dialog": UnitDialog,
    },
    data() {
        return {
            oldUnitExpressionId: '',
            curUnitExpressionId: '',
            data: [],
            pointData: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name",
            },
            defaultUnitProps: {
                children: "childList",
                label: "target_unit_name",
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            defaultPointCheckKeys: [],
            pointName: "",
            nodeKey: "target_unit_id",
            width: "calc(100% - 370px)",
            node_expression: "",
            point_ids: "",
            expreeBtns: [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                ".",
                "/",
                "(",
                ")",
                "*",
                "+",
                "-",
            ],
            unitVisible: false,
            unitId: "",
            pUnitId: "",
            treeUnitId: "",
            title: "新增部门",
            unitName: "",
            target_unit_type: "",
            selectTree: {},
            loading: false,
            curTargetMainId: "",
            unit_expression_id: "",
            nodelist: [],
            curHoverItem: null,
            curPoint: null,
            expressionList: [],
            oldUnitExpressionId: '',
            curUnitExpressionId: '',
        };
    },
    mounted() {
        this.getTreeUnitList();
    },
    methods: {
        // 获取左侧部门树
        getTreeUnitList() {
            getTargetUnitTreeList().then((res) => {
                if (res) {
                    this.data = res.bus_json;
                    this.defaultCheckKeys = [
                        res.bus_json &&
                        res.bus_json[0] &&
                        res.bus_json[0].target_unit_id,
                    ];
                    this.$nextTick(() => {
                        if (this.selectTree.target_unit_id) {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.selectTree.target_unit_id
                            );
                            this.selectTree = this.$refs.myTree.$refs.tree.getCurrentNode();
                        } else {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.defaultCheckKeys[0]
                            );
                            this.selectTree = res.bus_json && res.bus_json[0];
                        }
                        this.getPointList();
                        this.getTargetExpressionById();
                    });
                }
            });
        },
        getPointList() {
            getPointList({ unit_id: this.selectTree.unit_id }).then((res) => {
                if (res) {
                    this.pointData = res.bus_json;
                }
            })
        },
        appendTreeNode(data, parentNode, type) {
            if(!data) return;
            this.unitId = "";
            this.pUnitId = "";
            this.treeUnitId = "";
            this.unitName = "";
            this.target_unit_type = "";
            if(type=='add') this.$refs.myTree.$refs.tree.append(data, parentNode);
            else {
                const node = this.$refs.myTree.$refs.tree.getNode(data.target_unit_id);
                this.$set(node.data, 'target_unit_name', data.target_unit_name);
                this.$set(node.data, 'target_unit_type', data.target_unit_type);
                this.$set(node.data, 'sharp_price', data.sharp_price);
                this.$set(node.data, 'peak_price', data.peak_price);
                this.$set(node.data, 'off_price', data.off_price);
                this.$set(node.data, 'shoulder_price', data.shoulder_price);
                this.selectTree = data;
            }
        },
        // 新增修改删除部门成功回调
        closeUnitTree() {
            this.unitId = "";
            this.pUnitId = "";
            this.treeUnitId = "";
            this.unitName = "";
            this.target_unit_type = "";
            this.getTreeUnitList();
        },
        // 添加部门
        handleAddTreeNode(select) {
            this.unitId = this.selectTree.unit_id;
            this.pUnitId = this.selectTree.target_unit_id;
            this.treeUnitId = "";
            this.title = "新增部门";
            this.unitName = "";
            this.target_unit_type = "";
            this.sharp_price = "";
            this.peak_price = "";
            this.off_price = "";
            this.shoulder_price = "";
            this.unitVisible = true;
        },
        // 编辑部门
        handleEditTreeNode(select) {
            if(!this.selectTree.p_target_unit_id) {
                this.$message({
                    message: "企业级节点不能修改",
                    type: "info",
                });
                return;
            }
            this.unitId = this.selectTree.unit_id;
            this.pUnitId = this.selectTree.p_target_unit_id;
            this.treeUnitId = this.selectTree.target_unit_id;
            this.unitName = this.selectTree.target_unit_name;
            this.target_unit_type = this.selectTree.target_unit_type;
            this.sharp_price = this.selectTree.sharp_price;
            this.peak_price = this.selectTree.peak_price;
            this.off_price = this.selectTree.off_price;
            this.shoulder_price = this.selectTree.shoulder_price;
            this.title = "修改部门";
            this.unitVisible = true;
        },
        // 删除部门
        handleDelTreeNode(select) {
            if(!this.selectTree.p_target_unit_id) {
                this.$message({
                    type: "warning",
                    message: "根节点不能删除",
                });
                return;
            }
            this.pUnitId = this.selectTree.target_unit_id;
            this.$confirm("确定删除此部门?", "提示", {
                confirmButtonText: "确定",
                closeOnClickModal: false,
                cancelButtonText: "取消",
                
                type: "warning",
            })
                .then(() => {
                    delTargetUnitTree({
                        target_unit_id: this.pUnitId,
                    }).then((res) => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                message: res.error_msg,
                                type: "success",
                            });
                            this.$refs.myTree.$refs.tree.remove(this.selectTree);
                            const arr = []
                            this.focusParent(this.data, this.selectTree.p_target_unit_id, arr);
                            this.handleTreeNodeClick(arr[0]);
                            this.$refs.myTree.$refs.tree.setCurrentKey(arr[0].target_unit_id);
                            
                          /*  this.selectTree = {};
                            this.closeUnitTree(); */
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        focusParent(data, pId, arr) {
            data.forEach(item => {
                if(!item) return;
                if(item.target_unit_id == pId) {
                    arr.push(item);
                }
                if(item.childList && item.childList.length) this.focusParent(item.childList, pId, arr)
            })
        },
        // 点击部门树节点
        handleTreeNodeClick(select) {
            console.log(3333333, select)
            this.selectTree = select;
            this.nodelist = [];
            this.getTargetExpressionById();
        },

        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === "1") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state === "0") {
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                },
            };
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes
                ? "calc(100% - 370px)"
                : "calc(100% - 56px)";
        },
        // 计算器按钮点击回调
        clickCaculateBtn(caculateBtn) {
            const select = {point_name: caculateBtn};
            this.savePointName(select, 'a');
        },
        handlePointNodeClick(select) {
            if (select.state == 0) {
                this.savePointName(select, 't');
            } else {
                this.$message({
                    message: "当前采集点未安装采集器",
                    type: "warning",
                });
            }
        },
        savePointName(select, type) { //type =='a' 按键   type=='t'树
            if(!this.curPoint) {
                this.$message({
                    message: "请先选择一个节点",
                    type: "warning",
                });
            }
            this.nodelist.forEach(item => {
                if(item.id == this.curPoint.id) {
                    if(type == 'a') {
                        if(this.curPoint && this.curPoint.type == 'a') item.point_name += select.point_name;
                        else item.point_name = select.point_name;
                    }
                    else {
                        item.point_id = select.point_id;
                        item.point_name = select.point_name;
                    }
                    item.type = type;
                }
            })
        },
        // 清除公式
        resetExpress() {
            this.$confirm("确定清除此公式?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                closeOnClickModal: false,
                type: "warning",
            })
                .then(() => {
                    this.nodelist = [];
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消！",
                    });
                });
        },
        changelist(type, item, index) {
            let ran_id = this.random(1000000000, 1);
            if(type == 2) {//追加
                const point = {
                    id: ran_id,
                    point_id: '',
                    point_name: '',
                    type: 0,
                };
                this.nodelist.push(point);
                this.$nextTick(() => {
                    this.curPoint = point;
                });
            } else if(type == 0) {//插入
                const arr1 = this.nodelist.slice(0, index);
                const arr2 = this.nodelist.slice(index, this.nodelist.length);
                const point = {
                    id: ran_id,
                    point_id: '',
                    point_name: '',
                    type: 0,
                };
                arr1.push(point);
                this.nodelist = [...arr1, ...arr2];
                this.$nextTick(() => {
                    this.curPoint = point;
                });
            } else if(type == 1) {//删除
                const arr1 = this.nodelist.slice(0, index);
                const arr2 = this.nodelist.slice(index + 1, this.nodelist.length);
                this.nodelist = [...arr1, ...arr2];
                this.$nextTick(() => {
                    if(this.curPoint.id == item.id) {
                        
                         
                        this.curPoint = null;
                    }
                });
            }
        },
        random(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
        saveTargetExpression() {
            //先验证有无未填写的内容
            const unWrite = this.nodelist.filter(item => !item.point_name);     
            if(unWrite && unWrite.length>0){
                this.$message({
                    message: "请填写正确信息",
                    type: "warning",
                });
                return;
            } 
            this.loading = true;
            //保存上一次输入的东西
            this.saveLastData();
            this.genSaveParams(); 
            const params = {
                target_unit_id: this.selectTree.target_unit_id,
                target_main_id: this.curTargetMainId,
                expressionList: this.expressionList,
            };
            saveTargetExpression(params).then((res) => {
                if (res && res.error_code == 0) {
                    this.$message({
                        message: res.error_msg,
                        type: "success",
                    });
                    /*this.expressionList = [];
                    this.nodelist = [];
                    this.closeUnitTree();*/
                }
                this.loading = false;
            });
        },
        genSaveParams() {
            this.expressionList.forEach(item => {
                let doms = document.getElementsByClassName('el-message')[0];
                if(doms == undefined){
                    if(!item.start_time || !item.end_time) {
                        this.$message({
                            message: '请选择时间段',
                            type: "warning",
                        });
                        return;
                    }
                }
                item.point_ids = '';
                item.node_expression = '';
                item.nodelist && item.nodelist.forEach(data => {
                    if(data.type=='t') {
                        item.point_ids += data.point_id + ",";
                        item.node_expression += data.point_id + '$,';
                    } else {
                        item.node_expression += data.point_name + '&,';
                    }
                })
            })
        },
        getTargetExpressionById() {
            getTargetExpressionById({
                target_unit_id: this.selectTree.target_unit_id,
                target_main_id: this.curTargetMainId,
            }).then((res) => {
                if (res) {
                    this.expressionList = res.bus_json;
                    if(this.expressionList && this.expressionList.length) {
                        this.curUnitExpressionId = this.oldUnitExpressionId = this.expressionList[0].unit_expression_id;
                        this.expressionList.forEach(item => {
                            this.$set(item, "nodelist", []);
                            item.nodelist = [];
                            if(item.node_expression_show) {
                                const showArr = item.node_expression_show.split(',');
                                const idsArr = item.node_expression.split(',');
                                showArr && showArr.forEach((k, i) => {
                                    if(k) {
                                        const type = k.charAt(k.length - 1);
                                        if(type == '$') {
                                            item.nodelist.push({
                                                id: this.random(1000000000, 1),
                                                point_id: idsArr[i].substring(0, idsArr[i].length - 1),
                                                point_name: k.substring(0, k.length - 1),
                                                type: 't'
                                            });
                                        } else if(type == '&') {
                                            item.nodelist.push({
                                                id: this.random(1000000000, 1),
                                                point_id: '',
                                                point_name: k.substring(0, k.length - 1),
                                                type: 'a'
                                            });
                                        }
                                    }
                                });
                            }
                        })  
                        this.nodelist = this.expressionList && this.expressionList.length ? this.expressionList[0].nodelist : [];
                        this.clearCurrent();
                    } else {
                        const unit_expression_id = new Date().getTime();
                        this.expressionList = [];
                        this.expressionList.push({
                            unit_expression_id: unit_expression_id,
                            start_time: '1999-01-01 07:00:00',
                            end_time: '2099-01-01 07:00:00',
                            node_expression: '',
                            point_ids: '',
                        });
                        this.curUnitExpressionId = this.oldUnitExpressionId = unit_expression_id;
                        this.nodelist = [];
                        this.clearCurrent();
                    }
                }
            });
        },
        changeDateRadio() {
            //保存上一次输入的东西
            this.saveLastData();
            //回显
            this.expressionList.forEach(item => {
                if(item.unit_expression_id == this.curUnitExpressionId) {
                    this.nodelist = item.nodelist || [];
                }
            })
        },
        saveLastData() {
            this.expressionList.forEach(item => {
                if(item.unit_expression_id == this.oldUnitExpressionId) {
                    item.nodelist = this.nodelist;
                }
            })
            this.oldUnitExpressionId = this.curUnitExpressionId;
        },
        doAddDate() {
            this.expressionList.push(
                {
                    unit_expression_id: new Date().getTime(),
                    start_time: '',
                    end_time: '',
                    node_expression: '',
                    point_ids: '',
                }
            );
        },
        doMinusDate() {
            this.expressionList.pop();
            this.curUnitExpressionId = this.oldUnitExpressionId = this.expressionList[0].unit_expression_id;
            this.nodelist = this.expressionList[0].nodelist;
        },
    },
};
</script>
<style lang="scss">
.formula-department-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .active-table {
        background: #ff7455 !important;
        color: #fff !important;
        border-color: #ff7455 !important;
    }
    .tree-wrap {
        height: calc(100% - 10px);
        padding-top: 15px;
        box-sizing: border-box;
    }
    .right_container {
        height: 100%;
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
        .caculate-wrap {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            .formulaWrapper {
                width: 100%;
                min-height: 11rem;
                border: 1px solid #56fcff;
                border-radius: 6px;
                margin-top: 8px;
            }
            .text-wrap {
                width: 100%;
                // min-height: 11rem;
                // border: 1px solid #56fcff;
                // border-radius: 6px;
                color: #56fcff;
                font-size:1.2rem;
                line-height: 2em;
                padding: 0.6rem;
                box-sizing: border-box;
                display: flex;
                flex-flow: row wrap;
                cursor: pointer;
               //
                .text-div {
                    padding: 0 0.5rem 0 0; 
                    border-radius: 0.2rem; 
                    display: flex; 
                    align-items: center; 
                    height: 2rem;
                    color: #fff; 
                    margin-right: 0.6rem;
                    margin-bottom: 0.8rem;
                    // div {
                    //     cursor: pointer; 
                    //     margin-left: 5px; 
                    //     color: #fff;
                    //     display: inline-block;
                    // }
                    .doicon {
                        font-size: 0.8rem;
                        border-radius: 50%;
                        &:hover { 
                            background-color: rgb(165, 162, 162);
                        }
                    }
                    .doiconmargin {
                        margin-right: 0.5rem;
                    }
                    .icon_hidden {
                        visibility: hidden;
                    }
                }
                .text_single {
                    margin-right: 0.3rem; 
                    padding: 0.4rem; 
                    font-size: 0.9rem; 
                    width: 100%; 
                    height: 100%; 
                    line-height: 2rem;
                    min-width: 3rem;
                }
                .single_btn {
                    color: #ff0000;
                }
                .plus_btn {
                    height: 0.7rem; 
                    background-color:#e9575a;
                    border:1px solid #e9575a;
                    color: #fff;
                    padding: 0.6rem;
                    border-radius: 0.2rem; 
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                }
                .border-uncheck {
                    border: 1px solid #fff;
                }
                .border-check {
                    border: 1px solid #56fcff;
                }
                .border-unwrite {
                    border: 1px solid red;
                }
            }
            .express-btn {
                width: 36rem;
                margin-top: 20px;
                display: flex;
                flex-wrap: wrap;
                margin: 0 auto;
                margin-top: 2rem;
                .express-item {
                    margin-right: 0.7rem;
                    margin-bottom: 0.8rem;
                    width: 3rem;
                    height: 3rem;
                    background: linear-gradient(
                        -12deg,
                        #171533,
                        #063b7b,
                        #1e1837
                    );
                    border: 1px solid #56fcff;
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    color: #00e1d4;
                    cursor: pointer;
                }
            }
            .btn-wrap {
                width: 36rem;
                margin: 0 auto;
                margin-top: 1rem;
                margin-bottom: 20rem;
                .btn-inner-wrap {
                    display: inline-flex;
                    margin-left: 2rem;
                }
                .btn-clear,
                .btn-save {
                    width: 8.5rem;
                    height: 2.2rem;
                    line-height: 2.2rem;
                    text-align: center;
                    font-size: 1rem;
                    color: #fff;
                    border-radius: 0.3rem;
                    cursor: pointer;
                }
                .btn-clear {
                    background: #8e9eab;
                    border: 1px solid #3d3d3d;
                    margin-right: 5rem;
                }
                .btn-save {
                    background: linear-gradient(-12deg, #073775, #5c0991);
                    border: 1px solid #3d3d3d; 
                    margin-right: 1rem;
                }
            }
            .point_date {
                display: inline-flex;
                align-items:center;
                margin-top: 5px;
                width: 100%;
            }
        }
    }
    .border-left {
        border-left: 1px solid #56fcff;
    }
    .point-tree {
        height: 100%;
    }
    .point-type {
        height: 100%;
        width: 100%;
        margin: 14px;
        div {
            height: 35px;
            text-align: center;
            line-height: 35px;
            font-size: 14px;
            cursor: pointer;
        }
        .type_orange {
            border-bottom: 1px solid #ff6637;
            color: #ff6637;
        }
        .type_blue {
            border-bottom: 1px solid #56fcff;
            color: #56fcff;
        }
    }
}
.el-picker-panel__footer .el-button--text span{display: inline-block;background:#063b7b;border:1px solid #063b7b;padding:7px 15px;border-radius: 5px;}
</style>
